var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAlignTopSimple = function SvgIconAlignTopSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 2a1 1 0 0 0 0 2h13.5a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 5.75A1.75 1.75 0 0 0 7.25 7.5V21c0 .966.784 1.75 1.75 1.75h6A1.75 1.75 0 0 0 16.75 21V7.5A1.75 1.75 0 0 0 15 5.75zm.25 15v-13h5.5v13z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconAlignTopSimple;